// extracted by mini-css-extract-plugin
module.exports = {"container":"register_container__3AFUn","form":"register_form__3GR64"};